import React from "react";

const Stat_Hyp_Testing_Mean_Left_Tailed = () => {
  return (
    <div>
      <h1>Stat Hyp. Testing Mean (Left Tailed)</h1>
    </div>
  );
};

export default Stat_Hyp_Testing_Mean_Left_Tailed;
